import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'tr',
    fallbackLng: 'tr',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    supportedLngs: ['tr', 'en', 'de', 'fr', 'ar', 'ru'],
    nonExplicitSupportedLngs: true,
  });

export default i18n;